import {Checkbox, CheckboxIcon, CheckboxIndicator} from "@hosttools/frontend/components";
import {type CellContext} from "@tanstack/react-table";
import type React from "react";

const TableCheckBoxColumn: React.FC<CellContext<any, any>> = ({row}) => {
    return (
        <Checkbox
            isChecked={row.getIsSelected()}
            isDisabled={!row.getCanSelect()}
            isIndeterminate={row.getIsSomeSelected()}
            value="column" // not sure what this value is for?
            onChange={row.getToggleSelectedHandler()}
        >
            <CheckboxIndicator>
                <CheckboxIcon />
            </CheckboxIndicator>
        </Checkbox>
    );
};

export default TableCheckBoxColumn;
